import {AfterContentInit, Component, EventEmitter, Inject, ViewChild} from '@angular/core';
import { MatPaginator } from "@angular/material/paginator";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {HttpService} from "../../services/http/http.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AddCodeDialog} from "../add-code-dialog/add-code-dialog.component";

@Component({
  selector: 'lista-associazioni-dialog',
  templateUrl: './lista-associazioni-dialog.component.html',
  styleUrls: ['./lista-associazioni-dialog.component.scss'],
})
export class ListaAssociazioniDialog implements AfterContentInit {
  constructor(
    public dialogRef: MatDialogRef<ListaAssociazioniDialog>,
    public dialog: MatDialog,
    public api: HttpService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  onAssociazioneClick = new EventEmitter();
  filteredLista: any;
  title: string;

  displayedColumns: string[] = ['tipologia', 'competenza', 'stato', 'azioni'];
  dataSource : any;

  ngAfterContentInit(): void {
    this.filteredLista = this.data.lista;
    this.dataSource = this.filteredLista;
    this.title = this.data.tipo;
  }


  addCode(item: any) {

    this.api.precaricaCodiceProfilo(item.descrizioneArea.id, '').subscribe({
      next: (response: any) => {
        const dialogRef = this.dialog.open(AddCodeDialog, {
          data: { code: response.result.descrizione },
          // height: '95%',
        });

        dialogRef.afterClosed().subscribe((result: any) => {


          if (result) {

            let listIndex = this.filteredLista.findIndex((obj: any) => obj.descrizioneArea.id === item.descrizioneArea.id);

            this.filteredLista[listIndex].codiceProfilo = result.code;

            this.saveCode(result.code, item.idProposta);
          }
        });
      }
    });

  }

  saveCode(code: any, id: any) {
    this.api.assegnaCodiceProfilo({ codiceProfilo: code, idProposta: id }).subscribe({
      next: (response: any) => {
        this.snackBar.open('Codice aggiunto con successo', 'close', { panelClass: 'successSnack' });
      }
    });
  }


  dettaglioAssociazione(item: any) {
    this.onAssociazioneClick.emit(item);
  }


  onNoClick(): void {
    this.dialogRef.close();
  }
}
